import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function AcceptInviteModal({
  open,
  inviter,
  betAmount,
  onAccept,
  onDecline,
  onClose,
  gameType,
}) {
  const prevOpen = useRef(open);
  const navigate = useNavigate();

  useEffect(() => {
    if (open && !prevOpen.current) {
      // Play sound after user interaction
      const audio = new window.Audio("/sounds/notification.mp3");
      audio.volume = 0.5;
      audio.play().catch(() => {});
    }
    prevOpen.current = open;
  }, [open]);

  if (!open || !inviter) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-[#111927] rounded-2xl shadow-xl p-8 max-w-xs w-full flex flex-col items-center border-2 border-yellow-400/80 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-5 text-2xl font-black text-yellow-400 hover:text-yellow-300"
        >
          ×
        </button>
        <div className="mb-2 flex flex-col items-center">
          <div className="w-16 h-16 rounded-full bg-yellow-300 flex items-center justify-center text-3xl font-bold shadow-lg mb-2">
            {inviter.avatar ? (
              <img
                src={inviter.avatar}
                alt={inviter.username}
                className="w-16 h-16 rounded-full object-cover"
              />
            ) : inviter.username ? (
              inviter.username[0].toUpperCase()
            ) : (
              "U"
            )}
          </div>
          <span className="text-lg font-bold text-yellow-300 mb-1">
            {inviter.username || "Someone"}
          </span>
        </div>
        <div className="text-base text-slate-200 mb-5 text-center">
          invited you to play! <br /> {gameType}
          <span className="block mt-2 text-xl font-extrabold text-yellow-300">
            Bet: <span className="text-white">{betAmount} USDT</span>
          </span>
        </div>
        <div className="flex gap-4 w-full">
          <button
            // onClick={onAccept}
            onClick={() => {
              let path = "/";
              if (gameType === "xo") path = "/xogame";
              else if (gameType === "rps") path = "/rps";
              else if (gameType === "chess") path = "/chess";
              // add more as you add games
              navigate(path);
              onAccept();
            }}
            className="flex-1 bg-yellow-400 text-[#161f2b] font-bold rounded-xl py-3 text-lg shadow-xl hover:bg-yellow-300 transition"
          >
            Accept
          </button>
          <button
            onClick={onDecline}
            className="flex-1 bg-slate-400 text-[#161f2b] font-bold rounded-xl py-3 text-lg shadow-xl hover:bg-slate-300 transition"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
